import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import giftIcon from '../../images/gift-icon.png';
import teamIcon from '../../images/team-icon.png';
import loveIcon from '../../images/love-icon.png';

const UnifiedList = () => {
  return (
    <div className="UnifiedList">
      <Container>
        <Row>
          <Col md={4}>
            <Image src={giftIcon} />
            <h4 className="UnifiedList-Heading">Give some, get some</h4>
            <p className="UnifiedList-Content">Love our services? Refer us to a friend to earn discounts for the both of you! Click to learn more about our referral services.</p>
            <Link to="!#">Learn more</Link>
          </Col>
          <Col md={4}>
            <Image src={teamIcon} />
            <h4 className="UnifiedList-Heading">Be a team member</h4>
            <p className="UnifiedList-Content">Teamworking may be an integral part of our jobs, but what makes a great team player? Learn how to play to your strengths.</p>
            <Link to="!#">Join team</Link>
          </Col>
          <Col md={4}>
            <Image src={loveIcon} />
            <h4 className="UnifiedList-Heading">Rate our services</h4>
            <p className="UnifiedList-Content">We really value your positive ratings and hope you can help us by providing us with positive ratings on the services we have provided.</p>
            <Link to="!#">Review us</Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UnifiedList;